export default [{
    icon: ['left', 'fal', 'credit-card'],
    text: 'Credit Cards',
    color: 'purple',
    value: 'credit_card'
},
{
    icon: ['left', 'fal', 'hand-holding-usd'],
    text: 'Personal Loans',
    color: 'orange',
    value: 'personal_loan'
},
{
    icon: ['left', 'fal', 'heart-rate'],
    text: 'Medical Bills',
    color: 'lime',
    value: 'medical'
},
{
    icon: ['left', 'fal', 'user-graduate'],
    text: 'Student Loans',
    color: 'yellow',
    value: 'student_loan'
},
{
    icon: ['left', 'fal', 'car'],
    text: 'Auto Loan',
    color: 'blueish',
    value: 'auto_loan'
},
{
    icon: ['left', 'fal', 'file-invoice-dollar'],
    text: 'Other Debts',
    color: 'green',
    value: 'other'
}];